"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moduleFetchInApplicationReducer = exports.moduleUpdateReducer = exports.moduleCreateReducer = exports.moduleFetchReducer = exports.moduleFetchInApplicationSlice = exports.moduleUpdateSlice = exports.moduleCreateSlice = exports.moduleFetchSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const modulesAction_1 = require("./modulesAction");
const fetchInitialState = {
    loading: false,
    error: null,
    data: []
};
const createInitialState = {
    loading: false,
    error: null,
    data: []
};
const updateInitialState = {
    loading: false,
    error: null,
    data: []
};
const fetchModuleInApplicationInitialState = {
    loading: false,
    error: null,
    data: []
};
exports.moduleFetchSlice = (0, toolkit_1.createSlice)({
    name: 'module/fetch',
    initialState: fetchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(modulesAction_1.fetch.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(modulesAction_1.fetch.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(modulesAction_1.fetch.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.moduleCreateSlice = (0, toolkit_1.createSlice)({
    name: 'module/create',
    initialState: createInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(modulesAction_1.create.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(modulesAction_1.create.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(modulesAction_1.create.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.moduleUpdateSlice = (0, toolkit_1.createSlice)({
    name: 'module/update',
    initialState: updateInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(modulesAction_1.update.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(modulesAction_1.update.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(modulesAction_1.update.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.moduleFetchInApplicationSlice = (0, toolkit_1.createSlice)({
    name: 'module/fetchInApplication',
    initialState: fetchModuleInApplicationInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(modulesAction_1.fetchModulesInApplication.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(modulesAction_1.fetchModulesInApplication.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(modulesAction_1.fetchModulesInApplication.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.moduleFetchReducer = exports.moduleFetchSlice.reducer;
exports.moduleCreateReducer = exports.moduleCreateSlice.reducer;
exports.moduleUpdateReducer = exports.moduleUpdateSlice.reducer;
exports.moduleFetchInApplicationReducer = exports.moduleFetchInApplicationSlice.reducer;
